import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from "@ffmpeg/util";
import { Settings } from "./settings";

export class VideoProcessor {
  constructor() {
    this.ffmpeg = new FFmpeg();
  }

  async fixVideoDuration(blob) {
    try {
      console.log("Loading FFmpeg...");
      const { baseURL, coreURL, wasmURL } = Settings.ffmpeg;

      const fullCoreURL = `${baseURL}/${coreURL}`;
      const fullWasmURL = `${baseURL}/${wasmURL}`;

      console.log("Loading FFmpeg with URLs:", {
        coreURL: fullCoreURL,
        wasmURL: fullWasmURL,
      });

      await this.ffmpeg.load({
        coreURL: fullCoreURL,
        wasmURL: fullWasmURL,
      });

      console.log("FFmpeg loaded successfully");

      await this.ffmpeg.writeFile("input.mp4", await fetchFile(blob));

      // Fetch watermark image and write to FS
      const watermarkUrl = "/SHOT.png";
      const watermarkResp = await fetch(watermarkUrl);
      const watermarkBuf = await watermarkResp.arrayBuffer();
      await this.ffmpeg.writeFile("watermark.png", new Uint8Array(watermarkBuf));

      // Get output video dimensions from settings
      const width1 = Math.floor(window.innerWidth / 2) * 2;
      const height1 = Math.floor(window.innerHeight / 2) * 2;
      // Determine scale and position for watermark
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      const scale = isMobile ? 0.50 : 0.18;
      const margin = 0.05;
      // First, scale the video, then overlay the watermark at the correct size
      // [0:v]scale=width1:height1[bg];[1:v]scale=width1*scale:-1[wm];[bg][wm]overlay=(main_w-overlay_w)/2:main_h-overlay_h-(main_h*margin)
      const filterComplex =
        `[0:v]scale=${width1}:${height1}[bg];` +
        `[1:v]scale=${width1*scale}:-1[wm];` +
        `[bg][wm]overlay=(main_w-overlay_w)/2:main_h-overlay_h-(main_h*${margin})`;

      await this.ffmpeg.exec([
        "-i",
        "input.mp4",
        "-i",
        "watermark.png",
        "-filter_complex",
        filterComplex,
        ...Settings.ffmpeg.outputOptions.filter(opt => !opt.startsWith('-vf') && !opt.startsWith('scale=')),
        "output.mp4",
      ]);
      const fixedData = await this.ffmpeg.readFile("output.mp4");
      return new Blob([fixedData.buffer], {
        type: Settings.recording.mimeType,
      });
    } catch (error) {
      console.error("Error in fixVideoDuration:", error);
      throw error;
    }
  }
}
